import { ref } from 'vue';

export default function errorHandler() {
  const errorMessage = ref();
  const errorVisible = ref(false);
  const errorDetails = (val) => {
    errorMessage.value = val.response.data.error.errors[0].detail;
  };
  return {
    errorDetails,
    errorMessage,
    errorVisible
  };
}
